/**
 * Timers and transport limits (docs/design/05 §2, §6-7; owner decision Q26).
 *
 * The server enforces every timer with Durable Object alarms; clients only display them from the
 * *relative* `Clocks` in each message (client clocks drift, research 04 §2.4).
 */
export const TIMING = {
  /** Chess-clock bank per player: 25 minutes (Q26). Reaching zero loses the game. */
  bankMs: 25 * 60_000,
  /** Per-decision timer: 75 s (Q26). On expiry the server plays `defaultCommand`. */
  decisionMs: 75_000,
  /** Priority windows with no realistic response time out faster: 15 s (Q26). */
  emptyWindowMs: 15_000,
  /** A disconnected seat keeps its seat this long before the opponent may claim the win (Q26). */
  reconnectGraceMs: 60_000,
  /** A match abandoned before this turn records no result (Q26: "no result if abandoned before turn 3"). */
  noResultBeforeTurn: 3,
  /** Application-level keepalive (Cloudflare answers protocol pings itself, research 04 §7.3). */
  pingIntervalMs: 15_000,
  /** Missed pings before a seat is marked disconnected. */
  missedPingsBeforeDisconnect: 2,
  /** WebSocket tickets are single use and expire after 30 s. */
  ticketTtlMs: 30_000,
  /**
   * Auto-passes are delayed by a random amount in this range so response time doesn't reveal whether a
   * player holds a Reaction (05 §5 "timing tells", Q25).
   */
  autoPassDelayMs: { min: 400, max: 1_400 },
} as const;

export const TRANSPORT_LIMITS = {
  /** Largest inbound WebSocket frame. */
  maxFrameBytes: 16 * 1024,
  /** Inbound messages per second per socket. */
  maxMessagesPerSecond: 20,
  /** Recent log events replayed to a (re)connecting client in `welcome`. */
  welcomeRecentEvents: 200,
} as const;
